import { styled } from "@mui/material/styles";

export const StyledVideoWrapper = styled("div")(({ theme }) => ({
  marginTop: "24px"
}));
